import React, { useContext, useState, useEffect, useRef } from 'react';
import { DateTime } from 'luxon';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TableContext } from '../../context';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";

export default function TimeTest({ setSelectedTime, setLoading }) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [startDate, setStartDate] = useState(DateTime.now().minus({ weeks: 1 }));
    const [endDate, setEndDate] = useState(DateTime.now());
    const [temporaryDatePickerTime, setTemporaryDatePickerTime] = useState({start: DateTime.now().minus({ weeks: 1 }), end: DateTime.now()});
    const [temporaryTimeOptionTime, setTemporaryTimeOptionTime] = useState({start: DateTime.now().minus({ weeks: 1 }), end: DateTime.now()});
    const [showSetButton, setShowSetButton] = useState(false);
    const [lastChanged, setLastChanged] = useState('');

    const darkPrimaryTheme = createTheme({
        palette: {
            primary: {
            main: '#141414',
            },
        },
    });

    useEffect(() => {
        console.log('temporaryDatePickerTime:', temporaryDatePickerTime);
        console.log('temporaryTimeOptionTime:', temporaryTimeOptionTime);
        console.log('lastChanged:', lastChanged);
    }, [temporaryDatePickerTime, temporaryTimeOptionTime, lastChanged]);

    const handleDateChange = () => {
        const utcStartDate = startDate.toJSDate();
        const utcEndDate = endDate.toJSDate();
        setTemporaryDatePickerTime({ start: startDate.toISO(), end: endDate.toISO() });
        setSelectedTime({ start: utcStartDate, end: utcEndDate });
        setLoading(true);
        setIsDropdownOpen(false);
        setShowSetButton(false);
        setLastChanged('datePicker');
    };

    const handleTimeOptionClick = (start, end) => {
        const utcStartDate = DateTime.fromISO(start, { zone: 'UTC' }).toJSDate();
        const utcEndDate = DateTime.fromISO(end, { zone: 'UTC' }).toJSDate();
        setTemporaryTimeOptionTime({ start, end });
        setSelectedTime({ start: utcStartDate, end: utcEndDate });
        setLoading(true);
        setIsDropdownOpen(false);
        setLastChanged('timeOption');
    };

    const timeOptions = [
        { label: "Last week", start: DateTime.now().minus({ weeks: 1 }).toISO(), end: DateTime.now().toISO() },
        { label: "Last 2 weeks", start: DateTime.now().minus({ weeks: 2 }).toISO(), end: DateTime.now().toISO() },
        { label: "Last month", start: DateTime.now().minus({ months: 1 }).toISO(), end: DateTime.now().toISO() },
        { label: "Last 2 months", start: DateTime.now().minus({ months: 2 }).toISO(), end: DateTime.now().toISO() },
        { label: "Last 3 months", start: DateTime.now().minus({ months: 3 }).toISO(), end: DateTime.now().toISO() },
    ];

    const displayTime = lastChanged === 'datePicker' ? temporaryDatePickerTime : temporaryTimeOptionTime;

    return (
        <div style={{ position: 'relative', width: 'fit-content' }}>
            <div 
                style={{ 
                    width: '28vw', 
                    height: "fit-content", 
                    display: 'flex', 
                    alignItems: 'center', 
                    cursor: 'pointer', 
                    justifyContent: 'space-between', 
                    border: '1px solid black',
                    padding: '10px',
                    borderRadius: '5px',
                    gap: '5px'
                }}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
                <span style={{fontSize: "0.83rem"}}> Time: {DateTime.fromISO(displayTime.start, {zone: "UTC"}).toFormat('dd-MM-yyyy HH:mm:ss')} UTC - {DateTime.fromISO(displayTime.end, {zone: "UTC"}).toFormat('dd-MM-yyyy HH:mm:ss')} UTC</span>
                <McIcon
                    icon="chevron-down"
                    style={{ 
                        transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', 
                        transition: 'transform 0.3s ease',
                        color: '#141414' 
                    }}
                />
            </div>

            {isDropdownOpen && (
                <div style={{
                    display: 'flex',
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    border: '1px solid #ccc',
                    backgroundColor: 'white',
                    zIndex: 1000,
                    padding: '10px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    width: "100%",
                    justifyContent: 'space-between',
                    height: '28vh',
                    flexDirection: 'column',
                    overflowY: 'auto',
                    borderRadius: '5px',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '100%' }}>
                        <div style={{ marginRight: '10px', padding: '5px', width: "60%", display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <ThemeProvider theme={darkPrimaryTheme}>
                                <LocalizationProvider dateAdapter={AdapterLuxon}>
                                    <>
                                        <div style={{ marginBottom: '10px' }}>
                                            <label style={{fontSize: '0.8rem'}}>Start Date</label>
                                            <DateTimePicker
                                                ampm={false}
                                                value={startDate.setZone('UTC')}
                                                onChange={(date) => {
                                                    if (date) {
                                                        setStartDate(date);
                                                        setShowSetButton(date && endDate);
                                                    }
                                                }}
                                                // minDateTime={DateTime.now().minus({ days: 90 })}
                                                maxDateTime={endDate}
                                                textField={(params) => (
                                                    <input 
                                                        {...params} 
                                                        value={startDate ? startDate.toFormat('dd-MM-yyyy HH:mm:ss') : ''}
                                                    />
                                                )}
                                            />
                                        </div>
                                        <div>
                                            <label style={{fontSize: '0.8rem'}}>End Date</label>
                                            <DateTimePicker
                                                ampm={false}
                                                value={endDate.setZone('UTC')}
                                                onChange={(date) => {
                                                    if (date) {
                                                        setEndDate(date);
                                                        setShowSetButton(startDate && date);
                                                    }
                                                }}
                                                minDateTime={startDate}
                                                maxDateTime={DateTime.now()}
                                                textField={(params) => (
                                                    <input 
                                                        {...params} 
                                                        value={endDate ? endDate.toFormat('dd-MM-yyyy HH:mm:ss') : ''}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </>
                                </LocalizationProvider>
                            </ThemeProvider>
                            {showSetButton && (
                                <button 
                                    style={{
                                        marginTop: '10px', 
                                        padding: '5px 25px', 
                                        cursor: 'pointer', 
                                        backgroundColor: '#141414', 
                                        color: 'white', 
                                        border: 'none', 
                                        borderRadius: '5px'
                                    }}
                                    onClick={handleDateChange}
                                >
                                    Set Time
                                </button>
                            )}
                            <div style={{ height: '20px', opacity: '0' }}>" "</div>
                        </div>

                        <div style={{ width: '1px', backgroundColor: '#ddd', margin: '10px' }}></div>

                        <div style={{ display: 'flex', flexDirection: 'column', width: "40%", overflowY: 'auto' }}>
                            {timeOptions.map((option, index) => (
                                <div 
                                    key={index}
                                    style={{ padding: '5px', cursor: 'pointer', borderBottom: '1px solid #ddd' }}
                                    onClick={() => handleTimeOptionClick(option.start, option.end)}
                                >
                                    {option.label}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}